import { MessageDescriptor } from 'react-intl';
import { camelize } from 'lib/utility';
import { getIntlMessage } from './shared';
import { defaultMessages } from './default';

const getProfileElementLocale = (
  kind: string,
  section: string,
  key: string,
  nestedKey: string,
  defaultMessage: string,
): MessageDescriptor => {
  let intlMessage = getIntlMessage(`profile_elements_${kind}`, section, key, nestedKey);
  let message = defaultMessages[camelize(intlMessage)];

  if (!message && !nestedKey) {
    intlMessage = getIntlMessage(`profile_elements_${kind}`, section, key, 'label');
    message = defaultMessages[camelize(intlMessage)];
  }

  return message || { id: intlMessage.split(' ').join('.'), defaultMessage };
};

export default getProfileElementLocale;
